import Http from "@/libs/axios";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    itemSelectOptions: [],
  },
  getters: {
    items: (state) => {
      return state.items;
    },
    itemSelectOptions: (state) => {
      return state.itemSelectOptions;
    },
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      items.data.map((item) => {
        item.Allow_edit == "Y"
          ? (item.Allow_edit = true)
          : (item.Allow_edit = false);

        return item;
      });
      state.items = items;
    },
    SET_ITEM(state, item) {
      state.item = item;
    },
    SET_SELECT_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((code) => {
        let text = items[code] ?? null;
        return { value: code, text: `${code} - ${text}` };
      });

      state.itemSelectOptions = [
        { value: null, text: "Please select offence" },
        ...listOfObjects,
      ];
    },
  },
  actions: {
    getSelectOptions({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        Http.get("offence/select-options")
          .then((response) => {
            commit("SET_SELECT_OPTIONS", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("offence", { params: params })
          .then((response) => {
            commit("SET_ITEM_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    show({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        Http: get(`offence/${id}`)
          .then((response) => {
            commit("SET_ITEM", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.Allow_edit
          ? (payload.Allow_edit = "Y")
          : (payload.Allow_edit = "N");
        Http.post("offence", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    update({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.Allow_edit
          ? (payload.Allow_edit = "Y")
          : (payload.Allow_edit = "N");
        Http.put(`offence/${payload.Offence_index}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    destroy({}, { id }) {
      return new Promise((resolve, reject) => {
        Http.delete(`offence/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
